import {Pipe, PipeTransform} from "@angular/core";

/**
 * filters an array based on searctext
 */
@Pipe({
    name: "filterBy"
})
export class ArrayFilterPipe implements PipeTransform {
    public transform(array: any[], searchText?: string, keyName?: string) {
        if (!array || !searchText || !Array.isArray(array)) {
            return array;
        }
        if (typeof array[0] === 'string') {
            searchText = searchText.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            return array.filter((item) => this.exist(item, searchText));
        }
        // filter array, items which match and return true will be
        // kept, false will be filtered out
        if (!keyName) {
            return array.filter((item: any) => {
                for (const key in item) {
                    if (typeof item[key] !== "object" && this.exist(item[key].toString(), searchText)) {
                        return true;
                    }
                }
                return false;
            });
        } else {
            return array.filter((item: any) => {
                if (typeof item[keyName] !== "object" && this.exist(item[keyName].toString(), searchText)) {
                    return true;
                }
                return false;
            });
        }
    }

    private exist(target: string, needle: string): boolean {
        target = target.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return target.indexOf(needle.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")) > -1;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/pipes/filter-by.pipe.ts